import { Injectable } from '@angular/core';
import { SlServicesService } from '../sl-services/sl-services.service';
import { DataEnvService } from '../sl-data/data-env.service';
import { toPromise } from '../sl-data/util';

@Injectable()
export class SlAIService {

  constructor(
      private services: SlServicesService,
      private dataEnv: DataEnvService,
  ) { }

  public async processLogQuestion(jobId: number, question: string) {
    const comId = await this.comId();
      return this.services.callService('processLogQuestion', {comId, jobId, question});
  }

  public async processAgentQuestion(question: string, conversation: string): Promise<{success: boolean, answer: string}> {
      return this.services.callService('processAgentQuestion', {question, conversation});
  }

  public async createAiChatSession(title?: string): Promise<{ sessionId: string }> {
      return this.services.callService('createAiChatSession', { title });
  }

  public async sendAiChatMessage(sessionId: string, message: string, agentType: 'standard' | 'skillful' = 'standard'): Promise<{ success: boolean }> {
      return this.services.callService('sendAiChatMessage', { sessionId, message, agentType });
  }

  public async deleteAiChatSession(sessionId: string): Promise<{ success: boolean }> {
      return this.services.callService('deleteAiChatSession', { sessionId });
  }

  private async comId() {
    return toPromise(this.dataEnv.comId$);
  }

}
